import { DocumentConnection } from '../../common/model/document-connection-base';
import { ContactDocumentType, ContactDocumentTypeToString } from './const/documentEnums';

export class ContactDocument extends DocumentConnection<ContactDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return ContactDocumentTypeToString(this.connectionType);
  }

  contact: string;

  toJSON() {
    var result = super.toJSON();
    result['contact'] = this.contact;
    return result;
  }
}
